//----- Component --------------------------------------------------------/
// Developer     : Magali Perea
// Creation Date : 28/06/2023
// Version       : 1
// Description   : Menú para agregar tanques nuevos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   : 30/07/2025
// Change by     : Guillermo Sedran
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React from "react";
import { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import moment from "moment";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import InputMask from "react-input-mask";
import { v4 as uuidv4 } from "uuid";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Stack,
} from "@mui/material";

// ICONOS
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import PersonSearchSharpIcon from "@mui/icons-material/PersonSearchSharp";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Addtanque(props) {
  const [datosformulario, setDatosformulario] = useState({
    nro_serie: "",
    id_sisven: null,
    id_fabricante: null,
    fecha_fabricacion: null,
    fecha_compra: null,
    estado_fisico: null,
    capacidad: null,
    observaciones: null,
    baja: 0, //indica que el tanque no esta dado de baja
    fecha_ubicacion: null,
    id_estado: 2,
    fecha_estado: null,
    duenio: null,
    delivery_stop: "0",
    fecha_deliverystop: null,
    usuario: localStorage.getItem("user"),
    id_sucursal: null,
    vto_pruebahidraulica: null,
    incompleto: "",
    fecha_pruebahidraulica: null,
  });

  const [fabricantes, setFabricantes] = useState();
  const [sucursales, setSucursales] = useState();
  const [estados, setEstados] = useState();
  const [duenios, setDuenios] = useState();
  const [estadofisico, setEstadofisico] = useState();
  const [uuidTk, setUuidTk] = useState("");
  const [existe, setExiste] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success"); // "success" | "error"

  //*************************************************************************************************************************************/

  // DESHABILITAR BOTON AL GUARDAR
  const [disBtn, setDisBtn] = useState(false);

  //*************************************************************************************************************************************/

  const almacenar = (e) => {
    setDatosformulario({
      ...datosformulario,
      [e.target.name]: e.target.value,
    });
  };

  const obtenerEstados = () => {
    fetch(UrlApi + "/estados_tanques")
      .then((data) => data.json())
      .then((data) => setEstados(data));
  };

  const obtenerEstadoFisico = () => {
    fetch(UrlApi + "/desplegables/estadoFisicoTq")
      .then((data) => data.json())
      .then((data) => setEstadofisico(data));
  };

  const obtenerDuenios = () => {
    fetch(UrlApi + "/desplegables/dueniotanque")
      .then((data) => data.json())
      .then((data) => setDuenios(data));
  };

  const obtenerFabricantes = () => {
    fetch(UrlApi + "/fabricantes")
      .then((data) => data.json())
      .then((data) => setFabricantes(data));
  };

  const obtenerSucursales = () => {
    fetch(UrlApi + "/sucursales")
      .then((data) => data.json())
      .then((data) => setSucursales(data));
  };

  const obtenerRegistro = () => {
    fetch(
      UrlApi +
        `/tanques/existe/${datosformulario.nro_serie}/${datosformulario.id_fabricante}`
    )
      .then((data) => data.json())
      .then((data) => setExiste(data));
  };

  useEffect(() => {
    obtenerFabricantes();
    obtenerSucursales();
    obtenerEstados();
    obtenerEstadoFisico();
    obtenerDuenios();
    setUuidTk(uuidv4());
  }, []);

  useEffect(() => {
    if (datosformulario.nro_serie && datosformulario.id_fabricante) {
      obtenerRegistro();
    }
  }, [datosformulario.nro_serie, datosformulario.id_fabricante]);

  const handleClose = props.handleCloseAgregarTanque;

  // ================================================================

  const guardarTanque = async (e) => {
    e.preventDefault();
    console.log("Iniciando guardarTanque");

    if (existe.length > 0) {
      console.log("Datos ya existen:", existe);
      handleDatosExisten(e);
      setDisBtn(true);
    } else {
      setDisBtn(true);
      try {
        const response = await fetch(UrlApi + "/tanques", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...datosformulario,
            id_sisven:
              datosformulario.id_sisven === ""
                ? null
                : datosformulario.id_sisven,
            vto_pruebahidraulica:
              datosformulario.vto_pruebahidraulica === ""
                ? null
                : datosformulario.vto_pruebahidraulica,
            fecha_pruebahidraulica:
              datosformulario.fecha_pruebahidraulica === ""
                ? null
                : datosformulario.fecha_pruebahidraulica,
            incompleto: 0,
          }),
        });

        const json = await response.json();
        console.log("Respuesta del guardarTanque:", json);

        if (json.message) {
          console.log("Llamando a guardarMovimiento...");
          await guardarMovimiento();
        } else if (json.sqlMessage) {
          const errText = `SQL erróneo (${json.code} Errno: ${json.errno})`;
          console.error(errText);
          setSeverity("error");
          setMensaje(errText);
          setOpenSnack(true);
        } else {
          const errText = "ERROR DESCONOCIDO.";
          console.error(errText);
          setSeverity("error");
          setMensaje(errText);
          setOpenSnack(true);
        }
      } catch (err) {
        console.error("Error en guardarTanque:", err);
        setSeverity("error");
        setMensaje("ERROR INTERNO EN GUARDAR TANQUE.");
        setOpenSnack(true);
      }
    }
  };

  const guardarMovimiento = async () => {
    const payload = {
      id_sucursal: datosformulario.id_sucursal,
      usuario: datosformulario.usuario,
      uuid_tanque: uuidTk,
    };
    console.log("Payload a enviar a /movimientos_tanques:", payload);

    const response = await fetch(UrlApi + "/movimientos_tanques", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errText =
        "Inconvenientes con la API. No se pudo guardar movimiento.";
      console.error(errText);
      setSeverity("error");
      setMensaje(errText);
      setOpenSnack(true);
      return;
    }

    try {
      const json = await response.json();
      console.log("Respuesta del guardarMovimiento:", json);

      if (json.message === "OK") {
        setSeverity("success");
        setMensaje("Guardado satisfactoriamente");
        setOpenSnack(true);
        props.onTanqueGuardado(); // RECARGAR TABLA
      } else if (json.sqlMessage) {
        const errText = `SQL erróneo (${json.code} Errno: ${json.errno})`;
        console.error(errText);
        setSeverity("error");
        setMensaje(errText);
        setOpenSnack(true);
      } else {
        const errText = "ERROR DESCONOCIDO.";
        console.error(errText);
        setSeverity("error");
        setMensaje(errText);
        setOpenSnack(true);
      }
    } catch (err) {
      console.error(
        "Error al parsear JSON de respuesta en guardarMovimiento:",
        err
      );
      setSeverity("error");
      setMensaje("ERROR AL PROCESAR RESPUESTA.");
      setOpenSnack(true);
    }
  };

  //************************************************************************************************** */

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const handleFechaPH = (e) => {
    const fecha = moment(e.target.value).format("YYYY-MM-DD");
    const vencimiento = moment(moment(fecha).add(10, "y")._d).format(
      "YYYY-MM-DD"
    );
    setDatosformulario({
      ...datosformulario,
      fecha_pruebahidraulica: e.target.value,
      vto_pruebahidraulica: vencimiento,
    });
  };

  const handleDatosExisten = (e) => {
    e.preventDefault();
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDisBtn(false);
  };

  //*************************************************************************************************************************************/

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
    if (severity === "success") {
      // props.onTanqueGuardado();
      handleClose();
    }
    if (severity === "error") {
      setDisBtn(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          border: "2px solid #2B76A6",
          borderRadius: 1,
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1976D2",
            color: "white",
            position: "relative",
            textAlign: "center",
            px: 4,
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              left: 8,
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
            }}
            aria-label="volver"
          >
            <ArrowBackIcon />
          </IconButton>

          <Typography variant="h6" component="div" sx={{ color: "white" }}>
            Nuevo Tanque{" "}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <form onSubmit={guardarTanque}>
            <Grid container mt={0.8} spacing={2} mb={1}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  autoFocus
                  style={style}
                  placeholder="Numero de serie"
                  inputProps={{
                    maxLength: 15,
                  }}
                  type="text"
                  required
                  focused
                  name="nro_serie"
                  id="nro_serie"
                  label="N° de Serie"
                  color="primary"
                  onChange={almacenar}
                  value={datosformulario.nro_serie}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <StickyNote2Icon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  placeholder="Id Sisven"
                  style={style}
                  focused
                  name="id_sisven"
                  label="Número Sisven"
                  color="primary"
                  onChange={almacenar}
                  value={datosformulario.id_sisven}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{
                    maxLength: 8,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <StickyNote2Icon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <InputMask
                  mask="99.99"
                  value={datosformulario.capacidad}
                  disabled={false}
                  maskChar="0"
                  onChange={almacenar}
                >
                  {() => (
                    <TextField
                      size="small"
                      style={style}
                      required
                      type="text"
                      focused
                      name="capacidad"
                      label="Capacidad (m3)"
                    />
                  )}
                </InputMask>
              </Grid>

              <Grid item xs={2}>
                <FormControl fullWidth focused required style={style}>
                  <InputLabel>Nuevo / Usado</InputLabel>
                  <Select
                    size="small"
                    name="estado_fisico"
                    focused
                    InputLabelProps={{ shrink: true, required: true }}
                    value={datosformulario.estado_fisico}
                    label="Nuevo / Usado"
                    onChange={almacenar}
                  >
                    {estadofisico
                      ? estadofisico.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.valor}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={2}>
                <TextField
                  size="small"
                  style={style}
                  focused
                  color="primary"
                  label="Fecha Compra"
                  name="fecha_compra"
                  type="date"
                  onChange={almacenar}
                  value={moment(datosformulario.fecha_compra).format(
                    "YYYY-MM-DD"
                  )}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    min: datosformulario.fecha_fabricacion,
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl focused style={style}>
                  <InputLabel>Dueño</InputLabel>
                  <Select
                    size="small"
                    name="duenio"
                    focused
                    InputLabelProps={{ shrink: true, required: true }}
                    value={datosformulario.duenio}
                    label="Dueño"
                    onChange={almacenar}
                  >
                    {duenios
                      ? duenios.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.valor}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl focused required style={style}>
                  <InputLabel>Fabricante</InputLabel>
                  <Select
                    size="small"
                    name="id_fabricante"
                    focused
                    InputLabelProps={{ shrink: true, required: true }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={datosformulario.id_fabricante}
                    label="Fabricante"
                    onChange={almacenar}
                  >
                    {fabricantes
                      ? fabricantes.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.nombre}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl style={style} focused required>
                  <InputLabel>Sucursal</InputLabel>
                  <Select
                    size="small"
                    name="id_sucursal"
                    focused
                    InputLabelProps={{ shrink: true, required: true }}
                    labelId="demo-simple-select-label"
                    value={datosformulario.id_sucursal}
                    label="Sucursal"
                    onChange={almacenar}
                  >
                    {sucursales
                      ? sucursales.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.nombre}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={2}>
                <FormControl style={style} focused>
                  <InputLabel disabled>Estado</InputLabel>
                  <Select
                    size="small"
                    disabled
                    required
                    name="id_estado"
                    focused
                    InputLabelProps={{ shrink: true, required: true }}
                    value={datosformulario.id_estado}
                    label="Estado"
                    onChange={almacenar}
                  >
                    {estados
                      ? estados.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.estado}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={2}>
                <TextField
                  size="small"
                  style={style}
                  focused
                  color="primary"
                  label="Fecha Estado"
                  name="fecha_estado"
                  type="date"
                  onChange={almacenar}
                  value={moment(datosformulario.fecha_estado).format(
                    "YYYY-MM-DD"
                  )}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    min: datosformulario.fecha_compra,
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  size="small"
                  style={style}
                  focused
                  color="primary"
                  id="date"
                  label="Fecha Fabricacion"
                  name="fecha_fabricacion"
                  type="date"
                  onChange={almacenar}
                  value={moment(datosformulario.fecha_fabricacion).format(
                    "YYYY-MM-DD"
                  )}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    max: moment(new Date()).format("YYYY-MM-DD"),
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  size="small"
                  style={style}
                  focused
                  color="primary"
                  label="Fecha Ingreso Sucursal"
                  name="fecha_ubicacion"
                  type="date"
                  onChange={almacenar}
                  value={moment(datosformulario.fecha_ubicacion).format(
                    "YYYY-MM-DD"
                  )}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    min: datosformulario.fecha_compra,
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  size="small"
                  style={style}
                  focused
                  color="primary"
                  label="Fecha Prueba Hidráulica"
                  name="fecha_pruebahidraulica"
                  type="date"
                  onChange={(e) => handleFechaPH(e)}
                  value={moment(datosformulario.fecha_pruebahidraulica).format(
                    "YYYY-MM-DD"
                  )}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  size="small"
                  style={style}
                  focused
                  color="primary"
                  label="Vencimiento P. Hidráulica"
                  name="vto_pruebahidraulica"
                  type="date"
                  onChange={almacenar}
                  value={moment(datosformulario.vto_pruebahidraulica).format(
                    "YYYY-MM-DD"
                  )}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} mt={2}>
              <TextField
                size="small"
                style={style}
                focused
                color="primary"
                id="date"
                label="Observaciones"
                name="observaciones"
                onChange={almacenar}
                value={datosformulario.observaciones}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonSearchSharpIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid
              mt={3}
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button
                variant="contained"
                color="error"
                onClick={handleClose}
                disabled={disBtn}
              >
                Volver
              </Button>
              <Button
                disabled={
                  disBtn ||
                  datosformulario.capacidad === "0.00" ||
                  !datosformulario.capacidad
                }
                variant="contained"
                type="submit"
                color="primary"
              >
                Guardar Tanque
              </Button>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Registro existente</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Existe un registro de un tanque con el mismo número de serie y
            fabricante.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      {/* NOTIFICACIÓN */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default Addtanque;
